import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delay, Observable, of, retry } from 'rxjs';

@Injectable()
export class RetryHttpErrorRequestInterceptor implements HttpInterceptor {
    private retryRequestOptions = {
        maximumRetries: 3,
        retryDelay: 200
    };

    private retriableUrlPatterns: string[] = ['/AreAllBoundLendersUnavailable'];

    public intercept(request: HttpRequest<never>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (this.retriableUrlPatterns.some((pattern) => request.url.includes(pattern))) {
            return next.handle(request).pipe(this.retryPipe());
        } else {
            return next.handle(request);
        }
    }

    private retryPipe<T>() {
        return retry<T>({
            count: this.retryRequestOptions.maximumRetries,
            delay: (error: HttpErrorResponse, retryCount: number) => {
                return this.retryError(error, retryCount, this.retryRequestOptions.retryDelay);
            }
        });
    }

    private retryError(
        error: HttpErrorResponse,
        retryCount: number,
        retryDelay: number
    ): Observable<HttpErrorResponse> {
        return of(error).pipe(delay(retryDelay * retryCount));
    }
}
